import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Button = (props) => {
    const { className, children, type, ...buttonProps } = props;
    return <button { ...buttonProps } className={ 'a-button ' + (className || '') } type={ type }>{children}</button>
}

Button.defaultProps = {
    'type': 'button'
};

Button.propTypes = {
    'className': PropTypes.string,
    'children': PropTypes.any.isRequired,
    'type': PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/gdc-components-atoms-button/index.jsx